// src/routes/customersRoutes.jsx
import React from 'react';
import { Route } from 'react-router-dom';
import Customers from '../pages/customers/Customers';
import CustomerDetail from '../pages/customers/CustomerDetail';
import ProtectedRoute from '../components/global/ProtectedRoute';

const customersRoutes = (
    <>
        <Route
            path="/customers"
            element={
                <ProtectedRoute requiredPermission="customers.manage">
                    <Customers />
                </ProtectedRoute>
            }
        />
        <Route
            path="/customers/:id"
            element={
                <ProtectedRoute requiredPermission="customers.manage">
                    <CustomerDetail />
                </ProtectedRoute>
            }
        />
    </>
);

export default customersRoutes;
